import { useEffect } from 'react';

export const useNoScroll = ({
  scrollingDisabled,
  locationKey,
}: {
  scrollingDisabled: boolean;
  locationKey: string;
}) => {
  useEffect(() => {
    if (scrollingDisabled) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [scrollingDisabled]);

  useEffect(() => {
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [locationKey]);
};
